<div class="pnl {{class}}">
  <div class="pnl__title" *ngIf="heading">{{heading}}</div>
  <div class="pnl__content">
    <ng-content></ng-content>
  </div>
</div>
